export function centerSprite(sprites) {
    if (sprites instanceof Array) {
        for (let i=0;i<sprites.length;i++){
            sprites[i].setOrigin(0.5, 0.5);
        }
    }else{
        sprites.setOrigin(0.5, 0.5);
    }
};

export function enableUserClick(obj, listener, scope = undefined)
{
    obj.setInteractive({useHandCursor: true})
    if (listener)
    {
        obj.off('pointerup');
        if(scope)obj.on('pointerup', listener, scope);
        else obj.on('pointerup', listener);
    }
};

export function strPadLeft(value,pad,length) {
    return (new Array(length+1).join(pad)+value).slice(-length);
};